import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FlexLayoutModule } from "@angular/flex-layout";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpModule } from '@angular/http';

import { PdfViewerModule } from 'ng2-pdf-viewer';

import "rxjs/add/operator/toPromise";
//import 'hammerjs';

import { RequestManagementService } from './services/request-management.service';
import { DealStatusService } from './services/deal-status.service';
import { DealService } from './services/deal.service';
import { UserService } from './services/user.service';
import { GeneralService } from './services/general.service';
import { ServiceItemService } from './services/service-item.service';
import { ParameterService } from './services/parameter.service';
import { TermService } from './services/term.service';
import { TermOfUseService } from './services/term-of-use.service';
import { InfraService } from './services/infra.service';

import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { BaseRequestOptions } from '@angular/http';
import {
    MatButtonModule, MatCheckboxModule, MatButtonToggleModule, MatFormFieldModule, MatInputModule, MatIconModule,
    MatToolbarModule, MatDialogModule, MatSnackBarModule, MatProgressSpinnerModule, MatTooltipModule,MatDatepickerModule,MatNativeDateModule,
    MatSelectModule, MatRadioModule, MAT_DATE_LOCALE
} from '@angular/material';
import {
    MenubarModule, DataTableModule, ButtonModule, CheckboxModule,DragDropModule
} from 'primeng/primeng';

import { TableModule } from 'primeng/table';

import { DragulaModule } from 'ng2-dragula/ng2-dragula';

import { AuthorizationGuard } from './guards/authorization.guard';
import { NavigationGuard } from './guards/navigation.guard';

import { SignaturePadModule } from 'angular2-signaturepad';


import { DealStatusPipe } from './_pipes/deal-status.pipe';

import { AppComponent } from './components/app/app.component';
import { AlertDialogComponent } from './components/alert-dialog/alert-dialog.component';
import { HomeComponent } from './components/home-page/home/home.component';
import { TopMenuComponent } from './components/home-page/top-menu/top-menu.component';
import { LeftMenuComponent } from './components/home-page/left-menu/left-menu.component';
import { AppRoutingModule } from './app-routing.module';
import { DealStepperComponent } from './components/deal-wizard/deal-stepper/deal-stepper.component';
import { DealWizardComponent } from './components/deal-wizard/deal-wizard.component';
import { DealDetailsComponent } from './components/deal-wizard/deal-details/deal-details.component';
import { DealPackageComponent } from './components/deal-wizard/deal-package/deal-package.component';
import { DealServiceItemDialogComponent } from './components/deal-wizard/deal-package/deal-service-item-dialog/deal-service-item-dialog.component';

import { DealTermsItemDialogComponent } from './components/deal-wizard/deal-package/deal-terms-item-dialog/deal-terms-item-dialog.component';
import { DealTermsGridComponent } from './components/deal-wizard/deal-package/deal-terms-grid/deal-terms-grid.component';
import { DealTermsComponent } from './components/deal-wizard/deal-terms/deal-terms.component';
import { DealApprovalComponent } from './components/deal-wizard/deal-approval/deal-approval.component';
import { DealWelcomeComponent } from './components/deal-wizard/deal-welcome/deal-welcome.component';

import { ServiceItemDialogComponent } from './components/service-items/service-item-dialog/service-item-dialog.component';
import { DealsPageComponent } from './components/deals/deals-page/deals-page.component';
import { DealsGridComponent } from './components/deals/deals-grid/deals-grid.component';
import { ServiceItemsPageComponent } from './components/service-items/service-items-page/service-items-page.component';
import { ServiceItemsGridComponent } from './components/service-items/service-items-grid/service-items-grid.component';
import { LoginComponent } from './components/login/login.component';
import { UsersPageComponent } from './components/users/users-page/users-page.component';
import { UsersGridComponent } from './components/users/users-grid/users-grid.component';
import { ParametersGridComponent } from './components/parameters/parameters-grid/parameters-grid.component';
import { ParametersPageComponent } from './components/parameters/parameters-page/parameters-page.component';
import { TermsPageComponent } from './components/terms/terms-page/terms-page.component';
import { TermsGridComponent } from './components/terms/terms-grid/terms-grid.component';
import { UsersDialogComponent } from './components/users/users-dialog/users-dialog.component';
import { TermDialogComponent } from './components/terms/term-dialog/term-dialog.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { DealPaymentComponent } from './components/deal-wizard/deal-payment/deal-payment.component';
import { PictureDialogComponent } from './components/picture-dialog/picture-dialog.component';
import { SignatureDialogComponent } from './components/deal-wizard/deal-approval/signature-dialog/signature-dialog.component';

import { ItemDragging } from './_directives/item_drag.directive'
import {PrimeDragulaDirective } from './_directives/prime-dragula.directive';
import { TermsOfUsePageComponent } from './components/terms-of-use/terms-of-use-page/terms-of-use-page.component';
import { PermissionErrorPageComponent } from './components/permission-error-page/permission-error-page.component';
import { ApproveLoginComponent } from './components/login/approve-login/approve-login.component';
import { DealServiceItemsGridComponent } from './components/deal-wizard/deal-package/deal-service-items-grid/deal-service-items-grid.component';
import { ForgotPasswordDialogComponent } from './components/login/forgot-password-dialog/forgot-password-dialog.component';
import { ChangePasswordDialogComponent } from './components/login/change-password-dialog/change-password-dialog.component';

@NgModule({
    declarations: [
        AppComponent,
        AlertDialogComponent,
        TopMenuComponent,
        LeftMenuComponent,
        HomeComponent,
        DealStepperComponent,
        DealWizardComponent,
        DealDetailsComponent,
        DealServiceItemDialogComponent,
        DealTermsItemDialogComponent,
        DealPackageComponent,
        DealTermsComponent,
        DealApprovalComponent,
        DealWelcomeComponent,
        ServiceItemDialogComponent,
        DealTermsGridComponent,
        DealStatusPipe,
        DealsPageComponent,
        DealsGridComponent,
        ServiceItemsPageComponent,
        ServiceItemsGridComponent,
        LoginComponent, UsersPageComponent, UsersGridComponent, ParametersGridComponent, ParametersPageComponent, TermsPageComponent, TermsGridComponent, UsersDialogComponent, TermDialogComponent, ErrorPageComponent, DealPaymentComponent, PictureDialogComponent, SignatureDialogComponent
        , ItemDragging
        , PrimeDragulaDirective, TermsOfUsePageComponent, PermissionErrorPageComponent, ApproveLoginComponent, DealServiceItemsGridComponent, ForgotPasswordDialogComponent, ChangePasswordDialogComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        HttpModule,
        BrowserAnimationsModule,
        MenubarModule, DataTableModule, ButtonModule, CheckboxModule,DragDropModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatButtonModule, MatCheckboxModule, MatButtonToggleModule, MatFormFieldModule, MatInputModule, MatIconModule,
        MatToolbarModule, MatDialogModule, MatSnackBarModule, MatProgressSpinnerModule, MatTooltipModule, MatRadioModule, MatDatepickerModule, MatNativeDateModule,
        MatSelectModule,
        SignaturePadModule,
        DragulaModule,
        TableModule,
        PdfViewerModule
    ],
    entryComponents: [ServiceItemDialogComponent, DealServiceItemDialogComponent, AlertDialogComponent,
        DealTermsItemDialogComponent, UsersDialogComponent, TermDialogComponent, PictureDialogComponent,
        SignatureDialogComponent, ApproveLoginComponent, ForgotPasswordDialogComponent,
        ChangePasswordDialogComponent
    ],
    providers: [
        AuthorizationGuard,
        RequestManagementService,
        DealStatusService,
        DealService,
        ServiceItemService,
        UserService,
        ParameterService,
        TermService,
        TermOfUseService,
        GeneralService,
        InfraService,
        NavigationGuard,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: LOCALE_ID, useValue: 'en' },
        { provide: MAT_DATE_LOCALE, useValue: 'he-IL' }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts